
// player = https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement
import { Component, Vue, Prop } from 'vue-property-decorator'
import { FreeSpeakingConfigModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component({
  components: {
    FreeSpeakingConfigModal
  }
})

export default class SpeakingUtility extends Vue {
  @Prop({ required: true })readonly propertyId: number
  @Prop({ required: true })readonly propertyName: string
  @Prop({ required: true })readonly uploadAudioEndpoint: string
  @Prop({ required: true })readonly mergeAudioFilesEndpoint: string
  @Prop({ required: true })readonly processAudioEndpoint: string
  @Prop({ required: false })readonly processAudio: boolean
  @Prop({ required: true })readonly deleteAudioEndpoint: string
  @Prop({ required: false, default: true })readonly canDeleteAudio: boolean
  @Prop({ required: false, default: true })readonly canOpenConfigModal: boolean
  @Prop({ required: false })readonly audioFilePath: string
  @Prop({ required: false, default: true })readonly displayProcessAlertBeforeProcessAudio: boolean
  // @Prop({ required: false, default: false })readonly tryToDeleteAudioFileBeforeRecordNewOne: boolean

  data () {
    return this.getResetData()
  }

  getResetData () {
    return {
      isLoading: false,
      remainTime: '',
      disabled: true,
      isPlaying: false,
      isRecording: false,
      hasRecorded: false,
      filePath: '',
      maxDuration: 120000,
      currentTimeInterval: null,
      currentTimeMillis: 0,
      itWasPlaying: false,
      displayConfig: false,
      recordingEnded: false,
      localAudioTrack: null,
      audioStream: null,
      audioSource: null,
      recordBuffer: [],
      uploadChunkCount: null,
      recorderStartTimer: null,
      audioUrl: null,
      audioElement: null
    }
  }

  created () {
    this.$multiwatch(['audioFilePath'], function () {
      this.loadAudioFile(this.audioFilePath)
    })

    this.$multiwatch(['processAudio'], function () {
      if (this.processAudio) {
        if (this.displayProcessAlertBeforeProcessAudio) {
          this.displayModalFinish()
        } else {
          this.processAudioFiles()
        }
      }
    })
  }

  mounted () {
    this.loadAudioFile(this.audioFilePath)
  }

  setCurrentTimeTimeout () {
    this.currentTimeInterval = setInterval(this.updateCurrentTime, 1000)
  }

  updateCurrentTime () {
    this.currentTimeMillis += 1000
  }

  updatePlayerTime () {
    this.currentTimeMillis = Math.floor(this.audioElement.currentTime) * 1000
  }

  updatePlayerDuration () {
    this.maxDuration = Math.floor(this.audioElement.duration) * 1000
  }

  formatSecs (val) {
    var d = Math.abs(val) / 60000
    var mins = Math.floor(d)
    var secs = Math.floor((d - mins) * 60)
    var timerMins = mins === 0 ? '' : mins < 10 ? `0${mins}` : mins
    var timerSecs = secs < 10 ? `0${secs}` : secs
    return `${timerMins}${timerMins === '' ? '' : ':'}${timerSecs}`
  }

  async record () {
    if (!this.localAudioTrack) {
      this.openConfigModal()
    } else {
      /* if (this.tryToDeleteAudioFileBeforeRecordNewOne) {
        await this.deleteAudioFiles()
      } */
      this.isRecording = true
      this.hasRecorded = true
      this.setCurrentTimeTimeout()
      this.startRecordAudio()
    }
  }

  pause () {
    if (this.audioElement) {
      this.isPlaying = false
      this.audioElement.pause()
    } else {
      this.isRecording = false
      clearInterval(this.currentTimeInterval)
      this.stopRecordAudio()
      setTimeout(() => { this.mergeAudioFiles() }, 1000)
    }
  }

  play () {
    this.isPlaying = true
    this.audioElement.play()
  }

  playEnded () {
    this.pause()
  }

  closeConfigModal () {
    this.displayConfig = false
    if (this.itWasPlaying) {
      this.record()
      this.itWasPlaying = false
    }
  }

  openConfigModal () {
    if (this.isRecording) {
      this.itWasPlaying = true
      this.pause()
    }
    this.displayConfig = true
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.processAudioFiles()
      },
      onCancel: () => {
        this.$emit('cancelProcessing')
      },
      canCancel: true
    })
  }

  requestDeleteAudioFiles () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you will not be able to recover the recorded audio.',
      onConfirm: () => {
        this.deleteAudioFiles()
      },
      canCancel: true
    })
  }

  async startRecordAudio () {
    this.recordingEnded = false
    this.audioStream = new MediaStream([this.localAudioTrack])
    const options = { mimeType: 'audio/webm' }
    this.mediaRecorder = new MediaRecorder(this.audioStream, options)
    this.mediaRecorder.ondataavailable = this.handleDataAvailable
    this.mediaRecorder.onstop = this.handleRecorderStop
    this.recorderStartTimer = Number(`${this.currentTimeMillis}`)
    this.uploadChunkCount = 1
    this.mediaRecorder.start(1000)
  }

  stopRecordAudio () {
    this.recordingEnded = true
    this.mediaRecorder.stop()
    // clearInterval(this.playerInterval)
    // this.playerInterval = null
    // this.uploadToServer(this.recordedChunks.splice(0, this.recordedChunks.length), this.uploadChunkCount)
  }
  // updateRecordAudioTrack()

  resetCurrentTimeMillis () {
    this.currentTimeMillis = 0
  }

  handleDataAvailable (event) {
    if (event.data.size > 0) {
      if (this.recordBuffer.length === 0) {
        this.recordBuffer = [event.data]
      } else {
        this.uploadToServer(this.recordBuffer, this.uploadChunkCount)
        this.recordBuffer = [event.data]
        this.uploadChunkCount++
        if (this.uploadChunkCount === 120) {
          this.pause()
        }
      }
    } else {
      // …
    }
  }

  updateAudioInput (track) {
    this.localAudioTrack = track
  }

  async uploadToServer (data, chunkIdx) {
    const blob = new Blob(data, { type: 'audio/webm; codecs=opus' })
    // filename = '2-5612112-1.webm'
    const formData = new window.FormData()
    formData.append(
      'file', blob
    )
    formData.append(
      'chunkIdx', chunkIdx
    )
    formData.append(
      'recorderStartTimer', this.recorderStartTimer
    )
    formData.append(
      'recordingEnded', this.recordingEnded
    )
    formData.append(
      this.propertyName, this.propertyId
    )
    try {
      const resp = await FetchWrapper.postForm(`${process.env.VUE_APP_SERVERURL}/${this.uploadAudioEndpoint}`, formData)
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not upload audio chunk. Reason: ${e}`,
        canCancel: false
      })
      this.pause()
    }
  }

  async processAudioFiles () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/${this.processAudioEndpoint}/${this.propertyId}`))
      this.isLoading = false
      // await this.loadAudioFile(null)
      this.currentTimeMillis = 0
      this.$emit('processingFinished', resp)
    } catch (e) {
      this.isLoading = false
      this.currentTimeMillis = 0
      this.$emit('processingFinished', resp)
      this.$buefy.dialog.confirm({
        title: 'Error while processing audio file.',
        message: e.toString(),
        canCancel: false
      })
      // TODO: event.emit('audioProcessingError')
    }
  }

  async mergeAudioFiles () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/${this.mergeAudioFilesEndpoint}/${this.propertyId}`))
      this.isLoading = false
      await this.loadAudioFile(resp.filePath)
      this.$emit('audioMerged', resp.filePath)
    } catch (e) {
      this.isLoading = false
      await this.loadAudioFile('')
      this.$buefy.dialog.confirm({
        title: 'Error while merging audio files.',
        message: e.toString(),
        canCancel: false
      })
      // TODO: event.emit('audioMergedError')
    }
  }

  async loadAudioFile (filePath) {
    this.filePath = filePath
    if (this.audioElement) {
      this.audioElement.removeEventListener('ended', this.pause)
      this.audioElement.removeEventListener('timeupdate', this.updatePlayerTime)
      this.audioElement.removeEventListener('durationchange', this.updatePlayerDuration)
    }
    if (this.filePath !== '') {
      this.disabled = false
      this.audioUrl = encodeURI(`${process.env.VUE_APP_SERVERURL}/media/${this.filePath}?cb=${new Date().getTime()}`)
      const blob = await FetchWrapper.getBlob(this.audioUrl)
      const blobUrl = URL.createObjectURL(blob)
      this.audioElement = new Audio(blobUrl)
      this.audioElement.addEventListener('ended', this.pause)
      this.audioElement.addEventListener('timeupdate', this.updatePlayerTime)
      this.audioElement.addEventListener('durationchange', this.updatePlayerDuration)
      this.audioElement.load()
    } else {
      this.disabled = true
      this.hasRecorded = false
      this.audioUrl = null
      this.audioElement = null
      this.maxDuration = 120000
    }
  }

  async deleteAudioFiles () {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/${this.deleteAudioEndpoint}/${this.propertyId}`))
      await this.loadAudioFile('')
      await this.getResetData()
      this.$emit('audioDeleted')
      this.isLoading = false
      this.currentTimeMillis = 0
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not delete audio files.',
        canCancel: false
      })
    }
  }
}
